export default async ({ store }) => {
  await store.commit('returnvoucher/SET_PARTNER', {
    name: process.env.FRONT_PARTNER_NAME,
    link: process.env.FRONT_PARTNER_LINK,
    logo: process.env.FRONT_PARTNER_LOGO,
    src: process.env.FRONT_PARTNER_SRC
  })
}
